export enum MemberLevelUserProfile {
  Guest = 1,
  Premium = 2,
  PremiumPLUS = 3,
  Platinum = 4,
  PlatinumDiamond = 99,
  Plus = 101,
  Extras = 102,
  PlusExtras = 103,
}
